<template>
  <div>
    <b-spinner v-if="loading" />
    <div v-else>
      <b-form-group :label="$t('brand.notes.label')" label-for="notes-input">
        <b-form-textarea
          id="notes-input"
          v-model="notes"
          :placeholder="$t('brand.notes.placeholder')"
          :disabled="saving"
          rows="3"
        />
      </b-form-group>

      <div class="d-flex justify-content-end mt-3">
        <b-button
          variant="secondary"
          class="mr-2"
          :disabled="saving || !hasChanges"
          @click="cancelChanges"
        >
          {{ $t('brand.notes.cancel') }}
        </b-button>
        <b-button
          variant="primary"
          :disabled="saving || !hasChanges"
          @click="saveNotes"
        >
          <b-spinner small v-if="saving" class="mr-1" />
          {{ $t('brand.notes.save') }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapMutations, mapGetters } from 'vuex';
import { UPDATE_BRAND_NOTES } from '@/store/brands.module';

export default {
  name: 'BrandNotes',
  props: {
    brand: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      notes: '',
      originalNotes: '',
      loading: false,
      saving: false,
    };
  },
  computed: {
    ...mapGetters(['getBrandByAccountId']),
    hasChanges() {
      return this.notes !== this.originalNotes;
    },
  },
  watch: {
    brand: {
      immediate: true,
      handler() {
        this.loadNotes();
      },
    },
  },
  methods: {
    ...mapMutations([UPDATE_BRAND_NOTES]),

    loadNotes() {
      if (!this.brand?.id) {
        return;
      }

      this.loading = true;

      const storeBrand = this.getBrandByAccountId(this.brand.id);
      const notesFromStore = storeBrand?.notes;

      this.notes =
        notesFromStore !== undefined ? notesFromStore : this.brand.notes || '';
      this.originalNotes = this.notes;
      this.loading = false;
    },

    async saveNotes() {
      if (!this.brand?.id) {
        this.$bvToast.toast(this.$t('brand.notes.error.no-account'), {
          title: this.$t('brand.notes.error.title'),
          variant: 'danger',
        });
        return;
      }

      this.saving = true;

      try {
        await axios.patch(`/data-api/brand/${this.brand.id}`, {
          notes: this.notes,
        });

        this[UPDATE_BRAND_NOTES]({
          accountId: this.brand.id,
          notes: this.notes,
        });

        this.brand.notes = this.notes;
        this.originalNotes = this.notes;
        this.$bvToast.toast(this.$t('brand.notes.success'), {
          title: this.$t('brand.notes.success-title'),
          variant: 'success',
        });
      } catch (error) {
        console.error('Error saving notes:', error);
        this.$bvToast.toast(this.$t('brand.notes.error.save'), {
          title: this.$t('brand.notes.error.title'),
          variant: 'danger',
        });
      } finally {
        this.saving = false;
      }
    },

    cancelChanges() {
      this.notes = this.originalNotes;
    },
  },
};
</script>
